import { TAnalytics, TTextLogs } from '@/types/TAnalytics';
import { Line } from '@ant-design/plots';
import moment from 'moment';
import { useDateFormatFromCountry } from 'src/common/hooks/useDateFormatFromCountry';

export const AllTextLogs = ({ analyticsData }: TAnalytics) => {
	const { dateFormat } = useDateFormatFromCountry();

	const filteredData = analyticsData?.filter(
		(row) => row?.value !== undefined && typeof row.value === 'number',
	);

	if (!filteredData || filteredData.length === 0) {
		return <div>No text logs to display.</div>;
	}

	const config = {
		data: filteredData,
		xField: (row: TTextLogs) => moment(row.date, 'YYYY-M-D').format(`ddd ${dateFormat}`),
		yField: 'value',
		color: '#6e79d6', // ✅ solid blue line
		point: {
			shapeField: 'square',
			sizeField: 4,
		},
		legend: false,
		interaction: {
			tooltip: {
				marker: false,
			},
		},
		style: {
			lineWidth: 3,
		},
		tooltip: {
			title: 'date',
			items: [{ name: 'Total Texts', channel: 'y' }],
		},
	};
	return <Line {...config} />;
};
